import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { Checkbox, FormControlLabel, Grid, Menu } from "@mui/material"
import { ChangeEvent, MouseEvent, useState } from "react"
import { useLocalStorage } from "usehooks-ts"

export type BarStringsChartOptions = {
  isStacked: boolean
  showLabels?: boolean
}

export const BAR_STRINGS_CHART_OPTIONS_KEY = "bar-strings-chart-options"

export const defaultBarStringsChartOptions: BarStringsChartOptions = {
  isStacked: true,
}

type BarStringsChartOptionsDropdownProps = {
  defaultShowLabels?: boolean
}

const BarStringsChartOptionsDropdown = ({
  defaultShowLabels = true,
}: BarStringsChartOptionsDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const [options, setOptions] = useLocalStorage<BarStringsChartOptions>(
    BAR_STRINGS_CHART_OPTIONS_KEY,
    defaultBarStringsChartOptions,
  )

  const handleClick = (event: MouseEvent<HTMLDivElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const shouldShowLabels = options.showLabels ?? defaultShowLabels

  return (
    <>
      <Grid
        container
        onClick={handleClick}
        alignItems="center"
        sx={{
          cursor: "pointer",
          maxWidth: "fit-content",
          p: 1,
          "&:hover": { backgroundColor: "rgba(0, 0, 0, .04)" },
        }}
      >
        <Grid item>{anchorEl ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</Grid>
        <Grid item>Chart options</Grid>
      </Grid>

      <Menu
        id={BAR_STRINGS_CHART_OPTIONS_KEY}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": BAR_STRINGS_CHART_OPTIONS_KEY,
          sx: { width: "250px" },
        }}
      >
        <FormControlLabel
          sx={{ ml: 1 }}
          label="Show stacked bars"
          control={
            <Checkbox
              checked={options.isStacked}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked
                setOptions((prevState) => ({
                  ...prevState,
                  isStacked: checked,
                }))
              }}
            />
          }
        />
        <FormControlLabel
          sx={{ ml: 1 }}
          label="Show labels"
          control={
            <Checkbox
              checked={shouldShowLabels}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked
                setOptions((prevState) => ({
                  ...prevState,
                  showLabels: checked,
                }))
              }}
            />
          }
        />
      </Menu>
    </>
  )
}

export default BarStringsChartOptionsDropdown
